<template>
  <div class="upload-content-box" v-loading="loading">
    <!-- <el-button @click="getDropApi()"> Download template. </el-button> -->
    <el-button class="download-btn" @click="downloadTemplate()"> Download template. </el-button>

    <div
      class="form-wrap upload-form"
      :class="{ 'is-loading': is_loading, 'disabeld-box': $store.state.merchant_disabeld }"
    >
      <div v-show="uploadedFile && uploadedFile.dropActive" class="drop-active">
        <h3>Drop files to upload</h3>
      </div>
      <el-upload
        v-show="!files.length"
        drag
        :show-file-list="false"
        :before-upload="beforeUpload"
        :http-request="uploadManually"
        :accept="'.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
        ref="uploadedFile"
      >
        <div class="empty-box">
          <svg-icon name="upload" />
          <p>
            Drag and drop your CSV file here or <span class="a">click here to upload.</span><br />
            <span class="desc">Upload a .csv file. (Max. size: 5mb.)</span>
          </p>
          <el-button type="primary">Upload</el-button>
        </div>
      </el-upload>

      <div class="file-list" v-if="files.length">
        <div class="item" v-for="(file, index) in files" :key="file.id">
          <div class="ico">
            <img src="@/assets/images/csv.png" />
          </div>
          <div class="meta">
            <h3 class="name">{{ file.file.name }}</h3>
            <p class="size">{{ formatBytes(file.file.size, 0) }}</p>
          </div>
          <div class="remove" @click="files = []">
            <SvgIcon name="close-circle" />
          </div>
        </div>
        <el-button @click="triggerUpload">Replace</el-button>
      </div>
    </div>

    <p class="err-msg">{{ error_msg }}</p>
  </div>

  <el-dialog
    v-model="is_show_progress"
    :show-close="false"
    @close="closeProgressDialog()"
    class="upload-progress-dialog"
    width="850"
    :close-on-click-modal="false"
  >
    <div class="box" v-if="files.length > 0">
      <h2>
        <svg-icon name="retry" />
        Uploading your file. Please do not close this tab on your browser.
      </h2>

      <div class="progress" v-for="(file, index) in files" :key="file.id">
        <div
          :class="{
            'progress-bar': true,
            'progress-bar-striped': true,
            'bg-danger': file.error,
            'progress-bar-animated': file.active,
          }"
          role="progressbar"
          :style="{ width: progress + '%' }"
        ></div>
      </div>

      <div class="btn">
        <span class="text">{{ progress }}%</span>
      </div>

      <div class="btn-wrap">
        <el-button @click="doneUpload">Cancel</el-button>
      </div>
    </div>
  </el-dialog>

  <el-dialog v-model="is_show_postto" title="Download template" width="800" @close="is_show_postto = false">
    <PostTo
      @close="closePostTo"
      :creators="template_creators"
      :group="template_groups"
      :click_all="template_pick_all"
      :key="is_show_postto"
      :list="{ creatorList: creatorList, groupList: groupList }"
    />
  </el-dialog>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue';
import { ElButton, ElDialog, ElUpload } from 'element-plus';
import formatBytes from '@/utils/formatBytes';
import PostTo from '@/components/creator/CsvPickPostTo.vue';
import Papa from 'papaparse';

const props = defineProps({});

const loading = ref(false);
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const uploadedFile = ref(null); //ref
const files = ref([]); // uploaded files
const is_show_progress = ref(false);
const progress = ref(0);
const interval = ref(null);
const emit = defineEmits(['uploadSuccess', 'errFun']);
const is_loading = ref(false);
const error_msg = ref('');

const template_postto = ref({ type: 'all', data: [{ name: 'All' }] });
const template_creators = ref([]);
const template_groups = ref([]);
const template_pick_all = ref(true);
const is_show_postto = ref(false);
const creatorList = ref([]);
const groupList = ref([]);
//+++++++++++++++++++++++++++++++++++++

const frame = () => {
  if (progress.value >= 99) {
    window.clearInterval(interval.value);
  } else {
    progress.value++;
  }
};

const triggerUpload = () => {
  const input = uploadedFile.value?.$el.querySelector('input');
  if (input) input.click();
};

const REQUIRED_HEADERS = ['Member ID', 'Name', 'Current tags', 'Tags to be removed', 'Tags to be added'];

const checkCSVHeaders = (rows) => {
  const headerRow = rows[0].map((h) => h.trim());

  const missing = REQUIRED_HEADERS.filter((req) => !headerRow.includes(req));
  console.log('missing???', missing);
  if (missing.length > 0) {
    return { ok: false, missing };
  }

  return { ok: true };
};

const parseCSV = (file) => {
  return new Promise((resolve) => {
    Papa.parse(file, {
      skipEmptyLines: true,
      complete: (results) => {
        resolve(results.data);
      },
      error: (err) => {
        emit('uploadSuccess', []);
        files.value = [];
      },
    });
  });
};

const beforeUpload = async (file) => {
  const isValidExt = /\.(csv|xlsx|xls)$/i.test(file.name);
  if (!isValidExt) {
    error_msg.value = 'Only .csv, .xlsx, .xls are allowed';
    emit('uploadSuccess', []);
    files.value = [];
    return false;
  }

  const rows = await parseCSV(file);
  const result = checkCSVHeaders(rows);

  if (!result.ok) {
    error_msg.value = 'Incorrect file format';
    emit('uploadSuccess', []);
    files.value = [];
    return false;
  }

  // 把檔案存起來（模擬 v-model="files"）
  files.value = [{ file }];
  return true;
};

const uploadManually = () => {
  console.log('check');
  is_show_progress.value = true;
  interval.value = window.setInterval(frame, 30);

  let form_data = new FormData();

  form_data.append('batch_tag_update_file', files.value[0].file);
  console.log('files.value', files.value);
  ajax(`/batch-tag-update/import-from-file`, {
    method: 'post',
    data: form_data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      window.clearInterval(interval.value);
      progress.value = 100;
      is_show_progress.value = false;
      if(res.data.data && res.data.data.total_row_count > 500){
        files.value = [];
        error_msg.value = `Limit reached: You can upload a maximum of 500 creators. Please reduce the number of creators and try again.`;
        emit('uploadSuccess', []);
        return;
      }
      error_msg.value = '';
      emit('uploadSuccess', res.data.data);
    })
    .catch((err) => {
      is_show_progress.value = false;
      console.log('err', err);
      window.clearInterval(interval.value);
      progress.value = 0;
      let errMsg = err.response?.data?.data ? err.response.data.data.message : 'An error occurred. Please try again.';
      error_msg.value = errMsg;
      files.value = [];
      emit('uploadSuccess', []);
    });
};

const doneUpload = () => {
  is_show_progress.value = false;
  files.value = [];
};

const closeProgressDialog = () => {
  //emit('closeProgress')
};

const clearCsv = () => {
  files.value = [];
  error_msg.value = '';
};
//-----------------

const downloadTemplate = async () => {
  ajax
    .get('/batch-tag-update/get-template-list', {
      responseType: 'blob',
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'creator_template.csv'); //or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
};
const closePostTo = (val) => {
  is_show_postto.value = false;
  if (val) {
    if (val.type === 'all') {
      template_postto.value = { type: 'all', data: [{ name: 'All' }] };
      template_creators.value = [];
      template_groups.value = [];
      template_pick_all.value = true;
    } else {
      template_postto.value = { type: 'pick', data: [...val.data.creator, ...val.data.group] };
      template_creators.value = val.data.creator;
      template_groups.value = val.data.group;
      template_pick_all.value = false;
    }

    //call api to get template data(wait)
    is_show_postto.value = false;
  }
};

defineExpose({
  clearCsv,
});
</script>

<style lang="scss">
.upload-content-box {
  .download-btn {
    border: none;
    color: var(--blue);
  }

  .err-msg {
    color: var(--alert) !important;
  }

  .el-upload-dragger {
    padding: 28px;
    //border: none;
  }
  .upload-form {
    border-radius: 8px;
    border: 1px solid white;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23bdbdbd' stroke-width='2' stroke-dasharray='8%2c 12' stroke-dashoffset='5' stroke-linecap='square'/%3e%3c/svg%3e");
    width: 100%;
    margin: 12px 0;
    display: grid;
    gap: 8px;

    .el-upload {
      //padding: 28px;
    }

    &.is-loading {
      opacity: 0.5;
      pointer-events: none;
    }

    .drop-active {
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(#000, 0.65);
      color: var(--black-10);
      z-index: 99999999999999;

      h3 {
        font: var(--font-fg-18);
      }
    }
  }

  .file-uploads {
    display: block;
    cursor: pointer;

    & > label {
      cursor: pointer;
    }
  }

  .err-msg {
    color: var(--alert);
    margin-top: 8px;
  }

  .empty-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
    cursor: pointer;
    gap: 16px;

    img {
      width: 148px;
      display: block;
    }

    p {
      margin-left: 16px;
      color: var(--dark-blue);
      text-align: left;
      font: var(--font-fg-16);
      flex: 1;

      .a {
        color: var(--blue);
        //text-decoration: underline;
      }
    }

    svg {
      width: 56px !important;
      height: 56px !important;
      fill: var(--black-40);
    }

    .desc {
      font-size: 12px;
      color: var(--black-75);
      margin-bottom: 8px;
    }
  }

  .btn-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }

  .file-list {
    padding: 28px;
    display: flex;
    align-items: center;

    .item {
      display: flex;
      align-items: center;
      padding: 0 16px 0 0;
      background-color: white;
      flex: 1;

      .ico {
        width: 55px;
        height: 55px;

        img {
          height: 100%;
          width: 100%;
          display: block;
        }
      }

      .meta {
        flex: 1;
        padding: 8px;

        .name {
          font: var(--font-fg-12);
          color: var(--black-90);
        }

        .size {
          font-size: 12px;
          color: var(--black-60);

          &::after {
            content: ' ready';
          }
        }
      }

      .remove {
        height: 32px;
        width: 32px;
        cursor: pointer;

        svg {
          fill: none;
          height: 100%;
          width: 100%;
          display: block;
        }
      }
    }
  }

  .flex-btn span {
    display: flex;
    gap: 8px;
    align-items: center;
  }
}

.upload-progress-dialog {
  .el-dialog__header {
    display: none;
  }
  .btn-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }

  h2 {
    font: var(--font-med-24);
    color: var(--black-100);
    display: flex;
    gap: 16px;
  }

  svg {
    width: 32px;
    height: 32px;
    fill: var(--green);
  }

  p {
    margin: 0 0 14px;

    strong {
      font-weight: 600;
    }
  }

  .progress {
    height: 8px;
    background-color: var(--black-10);
    position: relative;
    margin-top: 24px;

    .progress-bar {
      height: 100%;
      position: absolute;
      left: 0;
      background-color: var(--dark-blue);
      transition: 0.1s width ease;
    }
  }

  .btn {
    display: flex;
    align-items: center;
    margin-top: 16px;
    font: var(--font-fg-14);

    .text {
      flex: 1;
      color: var(--dark-blue);
    }
  }
}
</style>
